import { IgChip } from "@intelligems/ig-theme";
import {
  IgCoreTextColors,
  IgInteractiveBackgroundColors,
} from "@intelligems/ig-design-tokens";

export const NavBadge = ({ label }: { label: string }) => (
  <IgChip
    color="default"
    label={label}
    size="small"
    sx={{
      backgroundColor: IgInteractiveBackgroundColors.accent.default,
      borderColor: "transparent",
      color: IgCoreTextColors.dark,
      fontWeight: 400,
      height: "20px !important",
      "& .MuiChip-label": {
        px: 1,
      },
    }}
  />
);
